var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleContributor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6958 19.2312C21.1483 19.079 20.5782 19 20 19H9.33333C7.65363 19 6.04272 19.6672 4.85499 20.855C3.66726 22.0427 3 23.6536 3 25.3333V28C3 28.5523 3.44772 29 4 29C4.55228 29 5 28.5523 5 28V25.3333C5 24.184 5.45655 23.0818 6.2692 22.2692C7.08186 21.4565 8.18406 21 9.33333 21H19.7223C20.3124 20.3407 20.9744 19.747 21.6958 19.2312Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 5C12.2735 5 10.3334 6.9401 10.3334 9.33333C10.3334 11.7266 12.2735 13.6667 14.6667 13.6667C17.0599 13.6667 19 11.7266 19 9.33333C19 6.9401 17.0599 5 14.6667 5ZM8.33337 9.33333C8.33337 5.83553 11.1689 3 14.6667 3C18.1645 3 21 5.83553 21 9.33333C21 12.8311 18.1645 15.6667 14.6667 15.6667C11.1689 15.6667 8.33337 12.8311 8.33337 9.33333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4362 19.4893L27.1636 22.2167L20.4895 28.8908L16.8957 29.7572L17.7621 26.1634L24.4362 19.4893Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3292 18.7279L26.2208 17.8364L28.8957 20.5113L28.0042 21.4029L25.3292 18.7279Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleContributor);
export default __webpack_public_path__ + "static/media/role-contributor.babc6a56944340d231862fc7d95c189b.svg";
export { ForwardRef as ReactComponent };